import { createHttpRequest } from 'src/utils/http-request';

import {
  BranchConfig,
  CheckModulesConfigResponse,
  MergeChecksApi,
  MergeChecksResourceApi,
} from './types';

export const mergeChecksApi = (url: string): MergeChecksApi => ({
  enableCheckModule: (
    checkModuleId: string,
    branchConfig: BranchConfig,
    required: boolean
  ) =>
    createHttpRequest<void>('PUT', {
      successCustomHandler: () => null, // don't parse 204 response as JSON
    })(`${url}/enable`, {
      extensionId: checkModuleId,
      branch: branchConfig,
      required,
    }),
  disableCheckModule: (checkModuleId: string, branchConfig: BranchConfig) =>
    createHttpRequest<void>('POST', {
      successCustomHandler: () => null, // don't parse 204 response as JSON
    })(`${url}/disable`, {
      extensionId: checkModuleId,
      branch: branchConfig,
    }),
});

export const mergeChecksResourceGetDataApi = (
  url: string
): MergeChecksResourceApi => ({
  getMergeCheckModules: () =>
    createHttpRequest<CheckModulesConfigResponse>('GET')(`${url}/modules`),
});
